var map = {
	"./logo-bredtmann-lg.png": 847,
	"./logo-bredtmann-md.png": 4079,
	"./logo-bredtmann-sm.png": 492,
	"./logo-bredtmann-xl - Kopie.png": 5677,
	"./logo-bredtmann-xl.png": 2048
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7351;